export const CATEGORIES = [
  { value: 'review', label: 'Review phim' },
  { value: 'news', label: 'Tin tức' },
  { value: 'advertise', label: 'Quảng cáo' },
  { value: 'book', label: 'Sách nói' },
  { value: 'education', label: 'Đào tạo' },
  { value: 'story', label: 'Đọc truyện' },
  { value: 'callcenter', label: 'Tổng đài' },
  { value: 'children', label: 'Trẻ em' },
];

export const AUDIO_TYPE = { WAV: 'wav' };

export const WHITESPACE_REGEX = /\s+/g;

export const TIME_PER_SYLLABLE = 500; // ms

export const MIN_TIME_PER_SENTENCE = 10000; // ms

export const MIN_AUDIO_DURATION = 2000; // ms

export const MILLISECONDS_PER_SECOND = 1000; // ms

export const RECORD_INTERVAL = 250; // ms

export const RECURSIVE_TIMEOUT = 100; // ms

export const PUNCTUATION_REGEX = /[!"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~]$/;

export const VOICE_LOCALES = {
  NORTHERN: 'northern',
  CENTRAL: 'central',
  SOUTHERN: 'southern',
};

export const GENDER = [
  { value: 'male', label: 'male' },
  { value: 'female', label: 'female' },
];

export const AUDIO_STATUS = {
  FAILED: 'failed',
  IMPROVEMENT_NEEDED: 'improvement_needed',
  PASSED: 'passed',
  REJECTED: 'rejected',
  APPROVED: 'approved',
};

export const NEW_AUDIO_STATUS = {
  FAILED: 'failed',
  PENDING: 'pending',
  PASSED: 'passed',
  GOOD: 'good',
};

export const AUDIO_STATUSES = [
  { value: 'allSentence', label: 'allSentence' },
  { value: AUDIO_STATUS.PASSED, label: 'passedSentence' },
  {
    value: AUDIO_STATUS.IMPROVEMENT_NEEDED,
    label: 'improvementNeededSentence',
  },
  { value: AUDIO_STATUS.FAILED, label: 'failedSentence' },
];

export const NEW_AUDIO_STATUSES = [
  { value: 'allSentence', label: 'allSentence' },
  { value: AUDIO_STATUS.PASSED, label: 'passedSentence' },
  { value: AUDIO_STATUS.FAILED, label: 'failedSentence' },
];

export const VOICE_STATUS = {
  RECORDING: 'recording',
  REJECTED: 'rejected',
  WAITING_RECEIVED: 'waiting-received',
  REVIEWING: 'reviewing',
  TRAINING: 'training',
  TRAINED: 'trained',
  READY: 'ready',
  USING: 'using',
  FAILED: 'failed',
  SUSPENDED: 'suspended',
};

export const VOICE_PROCESSING = [
  VOICE_STATUS.RECORDING, // dang thu am
  VOICE_STATUS.WAITING_RECEIVED, // cho tiep nhan
  VOICE_STATUS.REVIEWING, // dang kiem tra
  VOICE_STATUS.TRAINING, // dang huan luyen
  VOICE_STATUS.TRAINED, // da huan luyen
  VOICE_STATUS.REJECTED, // chua dat
];

export const VOICE_COMPLETED = [
  VOICE_STATUS.READY, // san sang su dung
  VOICE_STATUS.USING, // dang su dung
];

export const VOICE_NOT_USED = [
  VOICE_STATUS.FAILED, // khong thanh cong
  VOICE_STATUS.SUSPENDED, // dinh chi
];

export const REASON_VOICE_STATUS = [
  VOICE_STATUS.REJECTED,
  VOICE_STATUS.FAILED,
  VOICE_STATUS.SUSPENDED,
];

export const SUB_STATUS = {
  PASSED: 'passed',
  FAILED: 'failed',
  PENDING: 'pending',
  PROCESSING: 'processing',
  ERROR: 'error',
  PRIVATE: 'private',
  PUBLIC: 'public',
  WAITING_FOR_PUBLIC: 'waiting-for-public',
};

export const VOICE_STATUSES = [
  { value: '', label: 'all' },
  { value: VOICE_STATUS.RECORDING, label: 'recording' },
  { value: VOICE_STATUS.REJECTED, label: 'reject' },
  { value: VOICE_STATUS.WAITING_RECEIVED, label: 'waitingReceived' },
  { value: VOICE_STATUS.REVIEWING, label: 'reviewing' },
  { value: VOICE_STATUS.TRAINING, label: 'training' },
  { value: VOICE_STATUS.TRAINED, label: 'trained' },
  { value: VOICE_STATUS.READY, label: 'readyUsing' },
  { value: VOICE_STATUS.USING, label: 'using' },
  { value: VOICE_STATUS.FAILED, label: 'unsuccess' },
  { value: VOICE_STATUS.SUSPENDED, label: 'suspended' },
];

export const VOICE_STATUS_COLORS = {
  [VOICE_STATUS.RECORDING]: 'dark',
  [VOICE_STATUS.WAITING_RECEIVED]: 'info',
  [VOICE_STATUS.REVIEWING]: 'info',
  [VOICE_STATUS.TRAINING]: 'info',
  [VOICE_STATUS.TRAINED]: 'info',
  [VOICE_STATUS.REJECTED]: 'error',
  [VOICE_STATUS.READY]: 'success',
  [VOICE_STATUS.USING]: 'success',
  [VOICE_STATUS.FAILED]: 'error',
  [VOICE_STATUS.SUSPENDED]: 'error',
};

export const USERNAME_EXISTS = 4003;

export const LIMIT_CLONED_VOICE = 4021;

export const MAX_LENGTH_VOICE_NAME = 25;

export const MIN_LENGTH_USERNAME = 5;

export const MAX_LENGTH_USERNAME = 25;

export const VC_VOICE_CODE_REGEX =
  /[ncs]_[a-z]+_(male|female)_[a-z0-9]+_[a-z]+_vc+$/;

export const MAXIMUM_NUMBER_OF_ACTIVE_VOICES = 3;

export const MINIMUM_PERCENT_PASSED_QUALITY_OF_AUDIO = 0.8;

export const TIME_EXPIRE_QR_VOICE_CLONING = 1000 * 60 * 5; // 5 minutes

export const ORIGINAL_VOICE = 'originalVoice';

export const CLONE_VOICE = 'cloneVoice';

export const INSTANT_VOICE_CLONE = 'instantVoiceClone';

export const PRO_VOICE_CLONE = 'proVoiceClone';
